var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { sidebarActions } from '../actions/sidebarActions';
var initialState = {
    sidebarVisible: null,
};
if (window.innerWidth <= 768) {
    initialState.sidebarVisible = false;
}
else {
    initialState.sidebarVisible = true;
}
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case sidebarActions.SHOW_SIDEBAR:
            return __assign(__assign({}, state), { sidebarVisible: true });
        case sidebarActions.HIDE_SIDEBAR:
            return __assign(__assign({}, state), { sidebarVisible: false });
    }
    return state;
};
export default reducer;



//////////////////
// WEBPACK FOOTER
// ./src/reducers/sidebarReducer.ts
// module id = 633
// module chunks = 0